<div class="filterBar" [class.dayView]="isDayView">
  <p-floatlabel variant="on">
    <input pInputText id="search-label" [(ngModel)]="searchTerm" autocomplete="off" name="searchInput"
      (ngModelChange)="searchInput.next($event)" style="margin: 10px 0 0px 5px;"/>
    <label for="search-label"><i class="pi pi-search"></i> Search</label>
  </p-floatlabel>

  <div class="filterBoxContainer">
    @if (!isWellnessRenewal) {
    <div [class.dayView]="isDayView" class="filterBox" style="margin: -5px 0 0px 5px;">
      <p-button type="text" (click)="opDueDate.toggle($event)" severity="secondary" >
        Due Date <i class="pi pi-caret-down"></i>
      </p-button>
      <p-popover #opDueDate appendTo="body">
        <h6 class="first">
          Enabled
          <p-toggleswitch [(ngModel)]="shouldFilterByDueDate" (ngModelChange)="filterWorkOrders()" name="dueDateEnabled"
            [style]="{ 'font-size': '10px', 'vertical-align': 'middle' }"></p-toggleswitch>
        </h6>
        Show Work Orders with due date
        <p>
          after
          <input type="date" pInputText style="width: 150px; height: 30px" [max]="dueDateFilterToDate" name="dueDateStartInput"
            oninput="validity.valid||(value='');" [(ngModel)]="dueDateFilterFromDate"
            (ngModelChange)="filterWorkOrders()" />
        </p>
        <p>and</p>
        <p>
          before
          <input type="date" pInputText style="width: 150px; height: 30px" [min]="dueDateFilterFromDate" name="dueDateEndInput"
            oninput="validity.valid||(value='');" [(ngModel)]="dueDateFilterToDate"
            (ngModelChange)="filterWorkOrders()" />
        </p>
      </p-popover>
    </div>
    }
    @if (!isWellnessRenewal) {
    <div [class.dayView]="isDayView" class="filterBox" style="margin: -5px 0 0px 5px;">
      <p-button type="text" (click)="opGeoRegion.toggle($event)" severity="secondary">
        Geo Region <i class="pi pi-caret-down"></i>
      </p-button>
      <p-popover #opGeoRegion appendTo="body">
        <h6 class="first">
          Enabled
          <p-toggleswitch [(ngModel)]="shouldFilterByGeoRegion" (ngModelChange)="filterWorkOrders()" name="geoRegionEnabled"
            [style]="{ 'font-size': '10px', 'vertical-align': 'middle' }"></p-toggleswitch>
        </h6>
        Show Work Orders within
        <input type="number" min="0" oninput="validity.valid||(value='');" pInputText style="width: 60px; height: 30px" name="wosWithinInput"
          [(ngModel)]="geoRegionSearchRadius" (ngModelChange)="filterWorkOrders()" />
        <p>
          miles of Quote Number
          <input pInputText style="width: 85px; height: 30px" [(ngModel)]="geoRegionWorkOrderNumber" name="wosWithinNumberInput"
            (ngModelChange)="filterWorkOrders()" />
        </p>
        @if (geoRegionWorkOrderFindError) {
        <div class="alert alert-danger">
          {{ geoRegionWorkOrderFindError }}
        </div>
        }
        @if (geoRegionWorkOrderAddressError) {
        <div class="alert alert-danger">
          {{ geoRegionWorkOrderAddressError }}
        </div>
        }
      </p-popover>
    </div>
    }
    @if (!isWellnessRenewal) {
    <div [class.dayView]="isDayView" class="filterBox" style="margin: -5px 0 0px 5px;">
      <p-button type="text" (click)="opPriority.toggle($event)" severity="secondary">
        Priority <i class="pi pi-caret-down"></i>
      </p-button>
      <p-popover #opPriority appendTo="body">
        <h6 class="first">
          Enabled
          <p-toggleswitch [(ngModel)]="shouldFilterByPriority" (ngModelChange)="filterWorkOrders()" name="byPriorityEnabled"
            [style]="{ 'font-size': '10px', 'vertical-align': 'middle' }"></p-toggleswitch>
        </h6>
        Show items with Priority:<br />
        <p-multiselect autofocusFilter placeholder="Choose" [options]="priorityLevels" [(ngModel)]="selectedPriorities" optionLabel="status" name="prioritySelector"
          (ngModelChange)="filterWorkOrders()" [panelStyle]="{ minWidth: '16em' }">
          <ng-template let-value pTemplate="selectedItems">
            @for (val of value; track val) {
            <div class="p-multiselected-item-token p-corner-all">
              <span>{{ val.status }}</span>
            </div>
            }
            @if (!value || value.length === 0) {
            <span class="p-multiselected-empty-token p-corner-all"></span>
            }
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div style="font-size: 14px; float: right; margin-top: 4px">
              {{ item.status }}
            </div>
          </ng-template>
        </p-multiselect>
      </p-popover>
    </div>
  }
    @if (typeOfWorkOrders === 'wellness' && !isWellnessRenewal) {
    <div [class.dayView]="isDayView" class="filterBox" style="margin: -5px 0 0px 5px;">
      <p-button type="text" (click)="opGDD.toggle($event)" severity="secondary">
        GDD <i class="pi pi-caret-down"></i>
      </p-button>
      <p-popover #opGDD appendTo="body">
        <h6 class="first">
          Enabled
          <p-toggleswitch [(ngModel)]="shouldFilterByGDD" (ngModelChange)="filterWorkOrders()" name="gddEnabled"
            [style]="{ 'font-size': '10px', 'vertical-align': 'middle' }"></p-toggleswitch>
        </h6>
        Show Work Orders with Tasks having GDD
        <p>
          greater than
          <input type="number" min="0" oninput="validity.valid||(value='');" pInputText name="gddStartInput"
            style="width: 150px; height: 30px" [(ngModel)]="gddStart" (ngModelChange)="filterWorkOrders()" />
        </p>
        <p>and</p>
        <p>
          less than
          <input type="number" min="0" oninput="validity.valid||(value='');" pInputText name="gddEndInput"
            style="width: 150px; height: 30px" [(ngModel)]="gddEnd" (ngModelChange)="filterWorkOrders()" />
        </p>
      </p-popover>
    </div>
    }

    @if (!hideRMAndZip) {
    <div [class.dayView]="isDayView" class="filterBox" style="margin: -5px 0 0px 5px;">
      <p-button type="text" (click)="opRM.toggle($event)" severity="secondary">
        RM <i class="pi pi-caret-down"></i>
      </p-button>
      <p-popover #opRM appendTo="body">
        <h6 class="first">
          Enabled
          <p-toggleswitch [(ngModel)]="shouldFilterByRM" (ngModelChange)="filterWorkOrders()" name="rmEnabled"
            [style]="{ 'font-size': '10px', 'vertical-align': 'middle' }"></p-toggleswitch>
        </h6>
        Show items with RM:<br />
        <p-multiselect autofocusFilter placeholder="Choose" [options]="rms" [(ngModel)]="selectedRMs" optionLabel="fullName" name="rmSelector"
          (ngModelChange)="filterWorkOrders()" [panelStyle]="{ minWidth: '200px' }">
          <ng-template let-value pTemplate="selectedItems">
            @for (val of value; track val) {
            <div class="p-multiselected-item-token p-corner-all">
              <span>{{ val.fullName }}</span>
            </div>
            }
          </ng-template>
          <ng-template let-emp pTemplate="item">
            <div style="font-size: 14px; float: right; margin-top: 4px">
              {{ emp.fullName }}
            </div>
          </ng-template>
        </p-multiselect>
      </p-popover>
    </div>
    }

    @if (!isWellnessRenewal) {
    <div [class.dayView]="isDayView" class="filterBox" style="margin: -5px 0 0px 5px;">
      <p-button type="text" (click)="opEquipment.toggle($event)" severity="secondary">
        Equipment Type <i class="pi pi-caret-down"></i>
      </p-button>
      <p-popover #opEquipment appendTo="body">
        <h6 class="first">
          Enabled
          <p-toggleswitch [(ngModel)]="shouldFilterByEquipment" (ngModelChange)="filterWorkOrders()" name="equipmentEnabled"
            [style]="{ 'font-size': '10px', 'vertical-align': 'middle' }"></p-toggleswitch>
        </h6>
        Show items with Equipment:<br />
        @for (type of equipmentTypes; track type) {
        <div>
            <p-radiobutton [inputId]="type.fullName" name="equipment" [value]="type.fullName" [(ngModel)]="selectedEquipment" (ngModelChange)="filterWorkOrders()" />
            <label [for]="type.fullName">{{ type.fullName }}</label>
        </div>
        }
        </p-popover>
    </div>
    }

    @if (isWellnessRenewal && !hideRMAndZip) {
    <div [class.dayView]="isDayView" class="filterBox" style="margin: -5px 0 0px 5px;">
      <p-button type="text" (click)="opZip.toggle($event)" severity="secondary">
        Zip Code <i class="pi pi-caret-down"></i>
      </p-button>
      <p-popover #opZip appendTo="body">
        <h6 class="first">
          Enabled
          <p-toggleswitch [(ngModel)]="shouldFilterByZip" (ngModelChange)="filterWorkOrders()" name="zipCodeEnabled"
            [style]="{ 'font-size': '10px', 'vertical-align': 'middle' }"></p-toggleswitch>
        </h6>
        Show items with Zip Code:<br />
        <p-multiselect autofocusFilter placeholder="Choose" [options]="zipCodes" [(ngModel)]="selectedZipCodes" optionLabel="code" name="zipcodeSelector"
          (ngModelChange)="filterWorkOrders()" [panelStyle]="{ minWidth: '200px' }">
          <ng-template let-value pTemplate="selectedItems">
            @for (val of value; track val) {
            <div class="p-multiselected-item-token p-corner-all">
              <span>{{ val.code }}</span>
            </div>
            }
          </ng-template>
          <ng-template let-emp pTemplate="item">
            <div style="font-size: 14px; float: right; margin-top: 4px">
              {{ emp.value.code }}
            </div>
          </ng-template>
        </p-multiselect>
      </p-popover>
    </div>
    }


    <div [class.dayView]="isDayView" class="filterBox" style="margin: -5px 0 0px 5px;">
      <p-button type="text" (click)="opCreatedDate.toggle($event)" severity="secondary">
        Created Date <i class="pi pi-caret-down"></i>
      </p-button>
      <p-popover #opCreatedDate appendTo="body">
        <h6 class="first">
          Enabled
          <p-toggleswitch [(ngModel)]="shouldFilterByCreatedDate" (ngModelChange)="filterWorkOrders()" name="createdDateEnabled"
            [style]="{ 'font-size': '10px', 'vertical-align': 'middle' }"></p-toggleswitch>
        </h6>
        Show Work Orders with Created Date
        <p>
          after
          <p-datepicker id="createdDateStart" [(ngModel)]="createdDateStart" [showIcon]="true" name="createdOnStartInput"
            (ngModelChange)="filterWorkOrders()"></p-datepicker>
        </p>
        <p>and</p>
        <p>
          before
          <p-datepicker id="createdDateEnd" [(ngModel)]="createdDateEnd" [showIcon]="true" name="createdOnEndInput"
            (ngModelChange)="filterWorkOrders()"></p-datepicker>
        </p>
      </p-popover>
    </div>
    

    @if (isWellnessRenewal) {
    <div [class.dayView]="isDayView" class="filterBox" style="margin: -5px 0 0px 5px;">
      <p-button type="text" (click)="opCompletedDate.toggle($event)" severity="secondary">
        Completed Date <i class="pi pi-caret-down"></i>
      </p-button>
      <p-popover #opCompletedDate appendTo="body">
        <h6 class="first">
          Enabled
          <p-toggleswitch [(ngModel)]="shouldFilterByCompletedDate" (ngModelChange)="filterWorkOrders()" name="completedDateEnabled"
            [style]="{ 'font-size': '10px', 'vertical-align': 'middle' }"></p-toggleswitch>
        </h6>
        Show Work Orders with Completed Date
        <p>
          after
          <p-datepicker id="completedDateStart" [(ngModel)]="completedDateStart" [showIcon]="true" name="completedDateStartInput"
            (ngModelChange)="filterWorkOrders()"></p-datepicker>
        </p>
        <p>and</p>
        <p>
          before
          <p-datepicker id="completedDateEnd" [(ngModel)]="completedDateEnd" [showIcon]="true" name="completedDateEndInput"
            (ngModelChange)="filterWorkOrders()"></p-datepicker>
        </p>
      </p-popover>
    </div>
    }

    @if (isWellnessRenewal) {
    <div [class.dayView]="isDayView" class="filterBox" style="margin: -5px 0 0px 5px;">
      <p-button type="text" (click)="opRenewalAccepted.toggle($event)" severity="secondary">
        Auto Renewal Accepted <i class="pi pi-caret-down"></i>
      </p-button>
      <p-popover #opRenewalAccepted appendTo="body">
        <h6 class="first">
          Enabled
          <p-toggleswitch [(ngModel)]="shouldFilterByAutoRenewalSelected" (ngModelChange)="filterWorkOrders()" name="renewalAcceptedEnabled"
            [style]="{ 'font-size': '10px', 'vertical-align': 'middle' }"></p-toggleswitch>
        </h6>
        Enable to filter to Auto Renewal Accepted as "Yes"
      </p-popover>
    </div>
    }

    @if (isWellnessRenewal) {
    <div [class.dayView]="isDayView" class="filterBox" style="margin: -5px 0 0px 5px;">
      <p-button type="text" (click)="opRenewalStatus.toggle($event)" severity="secondary">
        Needs Renewed <i class="pi pi-caret-down"></i>
      </p-button>
      <p-popover #opRenewalStatus appendTo="body">
        <h6 class="first">
          Enabled
          <p-toggleswitch [(ngModel)]="shouldFilterByNeedsRenewed" (ngModelChange)="filterWorkOrders()" name="needsRenewedEnbled"
            [style]="{ 'font-size': '10px', 'vertical-align': 'middle' }"></p-toggleswitch>
        </h6>
        Enable to filter to Needs Renewed as "Yes"
      </p-popover>
    </div>
    }

    @if (showRefresh) {
    <div style="float: right; margin: -5px 0 0px 5px;">
      <p-button severity="info" label="Refresh" name="refreshButton"
        (click)="filterWorkOrders(true)"></p-button>
      <app-auto-refresh (refresh)="filterWorkOrders(true)"></app-auto-refresh>
    </div>
    }
  </div>
</div>
<div class="clear:both;"></div>